const checkoutBottomSheet = require('./checkoutBottomSheet');
const { changeViewToOnlyForm, changeViewToNormal } =
  require('./checkoutViewManager').methods;
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');
const {
  addCollapseClass,
  removeCollapseClass,
} = require('../common/utils/collapsible');
const {
  hideElementsBySelector,
  showElementsBySelector,
} = require('../common/utils/dom');
const clientSideValidation = require('../components/clientSideValidation');

const analyticsEventBus = getAnalyticsEventBus();

const resetPasswordBlocksToHideSelector =
  '.slot-promo-checkout-message, .checkout-container__content > *:not(.checkout-reset-password, .checkout-register)';
const registerBlocksToHideSelector =
  '.checkout-container__content > *:not(.checkout-reset-password, .checkout-register)';
const registerSelector = '.checkout-register-card';
const resetPasswordSelector = '.request-password-reset-modal';

function validateGuestLoginBusinessData() {
  // Form business logic validation
  return true;
}

function submitGuestLogin($form) {
  const form = $form[0]; // jq to element
  const url = $form.attr('action');
  const redirect = $form.attr('href');
  const errorMissing = $form.attr('data-missing-error');

  const formData = new FormData(form);
  const body = new URLSearchParams(formData);

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  })
    .then((res) => res.json())
    .then(({ success = false, errorMsg = errorMissing, order }) => {
      if (!success) {
        form.querySelector('#form-email-error').innerText = errorMsg;
      } else {
        $form.trigger('guest-form:success');
        // Send info for Analytics
        gaInfo.checkoutOptions.userAccess = 'guest';
        analyticsEventBus.publish(
          analyticsEventBus.EVENTS.checkoutProcessStarted,
          {
            order,
          }
        );
        window.location.href = `${redirect}?dlStep=2`;
      }
    });
}

function checksGuestLoginBeforeSubmit(e) {
  const $form = $(e.target);
  const form = $form[0]; // jq to element
  e.preventDefault();

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateGuestLoginBusinessData(form);

    if (isBusinessValid) {
      submitGuestLogin($form);
    }
  }
}

function handleResetPasswordShow(pushToHistory = true) {
  hideElementsBySelector(resetPasswordBlocksToHideSelector);
  changeViewToOnlyForm();
  removeCollapseClass(resetPasswordSelector);
  if (pushToHistory) {
    handleHistoryChange('reset-password');
  }
}

function handleRegisterShow(pushToHistory = true) {
  hideElementsBySelector(registerBlocksToHideSelector);
  if (pushToHistory) {
    handleHistoryChange('register');
  }
  setTimeout(() => {
    clientSideValidation.handleSubmitState(
      document.querySelector('form.registration')
    );
    removeCollapseClass(registerSelector);
  }, 100);
}

function removeShowClass(selector) {
  const element = document.querySelector(selector);
  if (element && element.classList.contains('show')) {
    element.classList.remove('show');
  }
}

function showCheckoutLogin(pushToHistory = true) {
  const backToLoginClass = '.back-to-login';
  if (pushToHistory) {
    handleHistoryChange('login');
  }
  setTimeout(() => {
    hideElementsBySelector(backToLoginClass);
    showElementsBySelector(resetPasswordBlocksToHideSelector);
    addCollapseClass(registerSelector);
    removeShowClass(registerSelector);
    addCollapseClass(resetPasswordSelector);
    removeShowClass(resetPasswordSelector);
    changeViewToNormal();
  }, 300);
}

function handleHistoryChange(step) {
  const urlParams = new URLSearchParams(window.location.search);
  if (step) {
    urlParams.set('step', step);
  } else {
    urlParams.delete('step');
  }
  window.history.pushState({}, document.title, `?${urlParams}`);
}

function init() {
  const searchParams = new URLSearchParams(window.location.search);
  const step = searchParams.get('step');
  switch (step) {
    case 'reset-password':
      handleResetPasswordShow(false);
      break;
    case 'register':
      handleRegisterShow(false);
      break;
    case 'login':
    default:
      showCheckoutLogin(false);
      break;
  }

  checkoutBottomSheet.initCheckoutBottomSheet();
}

function initializeOnlyInCheckoutLogin() {
  if (window.location.href.indexOf('checkout-login') !== -1) {
    init();
  }
}

module.exports = {
  listenGuestLoginSubmit() {
    $('body').on('submit', 'form.guest-form', checksGuestLoginBeforeSubmit);
  },
  createEventListeners() {
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    document
      .getElementById('password-reset')
      ?.addEventListener('click', handleResetPasswordShow);
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    document
      .querySelector('.reset-modal-btn-back')
      ?.addEventListener('click', showCheckoutLogin);
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    document
      .getElementById('registerButton')
      ?.addEventListener('click', handleRegisterShow);
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    document
      .getElementById('backToLoginFromResetPasswordForm')
      ?.addEventListener('click', showCheckoutLogin);
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    document
      .getElementById('backToLoginFromRegisterForm')
      ?.addEventListener('click', showCheckoutLogin);
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    window.addEventListener('popstate', initializeOnlyInCheckoutLogin);
  },
  initializeCheckoutLogin: init,
};
